export default class KeyDecisionSummaryEvent {
    constructor(type) {
        this.type = type;
    }
}

KeyDecisionSummaryEvent.CLOSE_REQUEST = "KeyDecisionSummaryEvent.CLOSE_REQUEST";